import React, { Fragment, useEffect, useState } from "react";
import { set_dispute_detail } from "../../../redux/actions/DisputesAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { set_loading } from "../../../redux/actions/LayoutAction";
import Header from "../subheader/Header";
import "./disputesdetails.scss";
import Message from "./components/Message";
import { useParams } from "react-router-dom";

const DisputesDetails = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [data, setData] = useState(false);
  const [messageSend, setMessageSend] = useState(false);
  const param = useParams();
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Dispute";
  }, []);

  useEffect(() => {
    apiJson.disputes.getDisputeDetail(parseInt(param.id)).then((response) => {
      if (response.success) {
        props.set_dispute_detail({ disputeDetail: response.data });
        setData(true);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(false);
      } else {
        setData(false);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSendClick = () => {
    setMessageSend(true);
    if (inputValue === "") {
      alert("Message not be empty.");
      setMessageSend(false);
    } else {
      apiJson.disputes
        .createReply(props.disputeDetail.id, {
          dispute_reply: {
            description: inputValue,
          },
        })
        .then((response) => {
          if (response.success) {
            setInputValue("");
            props.set_dispute_detail({
              disputeDetail: {
                ...props.disputeDetail,
                replies: [...props.disputeDetail.replies, response.data],
              },
            });
            setMessageSend(false);
          } else if (!response.status) {
            setMessageSend(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            setMessageSend(false);
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                ? response.errors
                : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    }
  };
  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);

  const classNames = props.disputeDetail.status === "open" ? "green" : "border";
  return (
    <Fragment>
      <div className="vendor-page-right disputesdetails-page-desktop">
        <Header heading="Disputes Details" search={false} filters={null} />
        <div className="right-content disputesdetails-page-content">
          {data && (
            <div className="content-container disputesdetails-page-container">
              <div className="content-wrapper">
                <div className="detail-row mx-auto d-flex">
                  <div className="dispute-detail d-flex flex-column">
                    <div className="detail d-flex">
                      <div className="label">Dispute #</div>
                      <div className="value">
                        {props.disputeDetail && props.disputeDetail.id}
                      </div>
                    </div>
                    <div className="detail d-flex">
                      <div className="label">Store:</div>
                      <div className="value">
                        {props.disputeDetail &&
                          props.disputeDetail.store_name_en}
                      </div>
                    </div>
                  </div>
                  <div className="customer-detail  d-flex flex-column">
                    <div className="detail d-flex">
                      <div className="label">Order #</div>
                      <div className="value">
                        {props.disputeDetail && props.disputeDetail.order_id}
                      </div>
                    </div>
                    <div className="detail d-flex">
                      <div className="label">Customer email:</div>
                      <div
                        className="value"
                        style={{ overflowWrap: "anywhere" }}
                      >
                        {props.disputeDetail &&
                          props.disputeDetail.customer_email}
                      </div>
                    </div>
                    <div className="detail d-flex">
                      <div className="label">Status:</div>
                      <div className="value">
                        <div className={classNames}>
                          {props.disputeDetail && props.disputeDetail.status}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-row mx-auto">
                  <div className="header">Replies: </div>
                  <div className="messages">
                    {props.disputeDetail?.replies?.map((message) => {
                      return (
                        <Message
                          message={message}
                          dispute={props.disputeDetail}
                          key={message.id}
                        />
                      );
                    })}
                  </div>
                  <form
                    action="
                  "
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSendClick();
                    }}
                  >
                    <div className="editor-row d-flex w-100">
                      <input
                        type="text"
                        name="message"
                        className="editor"
                        placeholder="Type Message Here"
                        value={inputValue}
                        onChange={handleChange}
                      />
                      <button
                        className="send-button"
                        type="submit"
                        onClick={handleSendClick}
                      >
                        {messageSend ? (
                          <ClipLoader color="#000" loading size={20} />
                        ) : (
                          "Send"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    disputeDetail: state.dispute.disputeDetail,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_dispute_detail, set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(DisputesDetails);
